import React, { memo, useCallback } from 'react';
import classnames from 'classnames';
import { Icon, Text } from '@Sage/hoi-poi-ui';

const ActionsMenu = memo(({ fieldSelectorProps, onToggleMenu }) => {
    const { actions } = fieldSelectorProps;

    const onClick = useCallback(
        (actionOnClick) => {
            onToggleMenu();
            actionOnClick();
        },
        [onToggleMenu],
    );

    const getActionsMenuItem = useCallback(
        (current) => {
            const { type, icon, id, label, onClick: onClickProp, disabled } = current;

            const actionClassNames = classnames('data-grid-field-selector__action', {
                [`data-grid-field-selector__action--${id}`]: id,
                [`data-grid-field-selector__action--disabled`]: disabled,
            });

            switch (type) {
                case 'divider':
                    return <div className="data-grid-field-selector__divider" />;
                case 'title':
                    return <div className="data-grid-field-selector__title">{label}</div>;
                default:
                    return (
                        <div className={actionClassNames} onClick={() => onClick(onClickProp)}>
                            {icon && (
                                <Icon
                                    className="data-grid-field-selector__action__icon"
                                    name={icon}
                                    color={current?.color || 'currentColor'}
                                />
                            )}
                            <Text
                                color={current?.color || ''}
                                className="data-grid-field-selector__action__label"
                            >
                                {label}
                            </Text>
                        </div>
                    );
            }
        },
        [onClick],
    );

    if (!actions || actions?.length === 0) return null;

    const finalActions = actions.map((current, index) => {
        const Item = () => getActionsMenuItem(current);
        return <Item key={`selector-action-${index}`} />;
    });

    return <div className="data-grid-field-selector__actions">{finalActions}</div>;
});

export default ActionsMenu;
